import mail from '../images/mail.png';
import phone from '../images/phone.png';
import css from '../images/css.png';
import git from '../images/git.png';
import html from '../images/html.png';
import javascript from '../images/javascript.png';
import node from '../images/node.png';
import react from '../images/react.png';
import redux from '../images/redux.png';
import typescript from '../images/typescript.png';
import NextJS from "../images/NextJS.png";
import gitHub from "../images/gitHub.png";
import mongoDb from "../images/mongoDb.png";
import expressJS from "../images/expressJS.png";
import vsCode from "../images/visualStudioCode.png"
import circle from '../images/circle.svg';
import robotic from "../images/robot-png-33316.png";
import Fahad from "../images/Fahad-Professional-1.jpeg";
import RelDigital from "../images/RelDigital.png";
import AirGarage from "../images/AirGarage.png";
import Fashion from "../images/Fashion.png";
import LoseIt from "../images/LoseIt.png";
import linkedin from "../images/linkedin.png";
import white from "../images/white-gif.gif";
import Trendy from "../images/Trendy.png";
import ShoppingQuest from "../images/shopping-quest.png";

export default {
  linkedin,
  mail,
  phone,
  css,
  git,
  html,
  javascript,
  node,
  react,
  redux,
  typescript,
  circle,
  robotic,
  Fahad,
  RelDigital,
  AirGarage,
  LoseIt,
  NextJS,
  gitHub,
  mongoDb,
  expressJS,
  vsCode,
  white,
  Fashion,
  Trendy,
  ShoppingQuest
};